/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_2Inputs */

const en_pc_tut_secure_2 = /** @type {(inputs: Pc_Tut_Secure_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the open password to view the document.`)
};

const zh_pc_tut_secure_2 = /** @type {(inputs: Pc_Tut_Secure_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入打开密码即可查看文档。`)
};

/**
* | output |
* | --- |
* | "Enter the open password to view the document." |
*
* @param {Pc_Tut_Secure_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_2 = /** @type {((inputs?: Pc_Tut_Secure_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_2(inputs)
	return zh_pc_tut_secure_2(inputs)
});
export { pc_tut_secure_2 as "pc.tut.secure.2" }